import { Game } from "../logic/Game";
import { GameUi } from "../ui/GameUi";

export class GameAgent {


    constructor(
        public readonly game: Readonly<Game>,
        public ui: GameUi
    ) {



    }

    public update(delta_seconds: number) {
        const x = Math.floor(this.game.map.width * Math.random());
        const y = Math.floor(this.game.map.height * Math.random());
        this.ui.select_field(x, y);
        const r = Math.random();
        const should_build = r < 0.05;
        if (should_build) this.ui.build_tower();
    }
}